import { LoadableAfterPaint } from '@confluence/loadable';

export const SuperAdminEntryPoint = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-SuperAdminEntryPoint" */ '../src/SuperAdminEntryPoint.js'
			)
		).SuperAdminEntryPoint,
});
